<template>
  <v-skeleton-loader
      class="mx-auto"
      min-height="200"
      type="table-heading, list-item-two-line, list-item-three-line"
    ></v-skeleton-loader>
</template>

<script>
export default {}
</script>

<style>

</style>